import {Component} from '@angular/core';
import {FilterService} from '../../../../services/filter.service';

@Component({
  selector: 'app-place-list-empty',
  imports: [],
  templateUrl: './place-list-empty.component.html',
  styleUrl: './place-list-empty.component.scss'
})
export class PlaceListEmptyComponent {

  constructor(private filterService: FilterService) {
  }

  clearFilters() {
    this.filterService.resetFilter();
  }

}
